import { useStaticQuery, graphql } from 'gatsby'

export const queryMember = () => {
  const query = useStaticQuery(
    graphql`
      {
        sanityMember {
          id
          internal {
            type
            content
            contentDigest
            owner
          }
        }
      }
    `
  )
  return JSON.parse(query.sanityMember.internal.content)
}
